import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import NonsocialUpdate from "../nonsocial_update";

export default GrComponentFactory.createClass({
  displayName: "AuthorQaSettingNewsfeedItem",

  propTypes: {
    resource: GrPropTypes.authorQaSettingNewsfeedResource(),
  },

  renderHeader() {
    const author = this.props.resource.author;
    return (
      <span>
        <a href={author.profileUrl}
           className="gr-hyperlink gr-hyperlink--bold">
          {author.name}
        </a> started an Ask the Author Session
      </span>);
  },

  renderBody() {
    return (
      <div>
        <div className="gr-newsfeedItem__qaMessage">
          { this.props.resource.message ? `“${this.props.resource.message}”` : "Join the conversation!" }
        </div>
        <a href={this.props.resource.url}
           className="gr-button u-marginBottomMedium u-marginTopSmall">
          Ask a Question
        </a>
      </div>
    );
  },

  render() {
    return (
      <NonsocialUpdate
        header={this.renderHeader()}
        body={this.renderBody()}
        updateIconUrl={this.props.resource.author.profileImage}
      />);
  },
});
